import { ShieldOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

// Landing page for a platform staff member whose role grants no page in this
// portal (e.g. a role with tenants.view only, which has no screen yet). Says
// so plainly rather than bouncing them between "/" and /login.
export default function NoAccess() {
  const { t } = useTranslation(['support']);
  return (
    <div data-testid="no-access-page" className="h-full flex items-center justify-center">
      <div className="text-center bg-white rounded-2xl shadow-md px-10 py-12 max-w-md">
        <ShieldOff className="w-12 h-12 mx-auto mb-4 text-gray-300" />
        <h1 className="text-xl font-bold text-gray-800 mb-2">
          {t('support.no_access_title', 'No pages available')}
        </h1>
        <p className="text-sm text-gray-500">
          {t('support.no_access_text', 'Your platform role does not grant access to any page here yet. Ask the Super Admin to add a permission to your role.')}
        </p>
      </div>
    </div>
  );
}
